/**
 * Where an old `/this-week` link goes now (#768).
 *
 * `/this-week` was a list of the Monday week the app happened to be on. It was
 * retired because the Du Chef Daily linked to it: on a Sunday, the email about
 * Monday opened the week that was ending, and every day label on it was a day
 * early (`new Date('2026-09-29')` is UTC midnight, Monday evening in Montreal).
 * The planner shows all of it, from today, with the dates right.
 *
 * The route stays as a redirect because the links do not go away: digests and
 * weekly emails already sitting in inboxes carry
 *
 *   /this-week                       → the planner
 *   /this-week?rate=<recipeId>       → that recipe, where a verdict is given
 *   /this-week?week=…&swap=…&day=…   → the planner's swap deep link
 */

type Param = string | string[] | undefined;

export interface LegacyThisWeekTarget {
  pathname: string;
  params: Record<string, string>;
}

const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/;

function first(value: Param): string | undefined {
  const v = Array.isArray(value) ? value[0] : value;
  return v && v.trim() ? v.trim() : undefined;
}

export function legacyThisWeekTarget(query: Record<string, Param>): LegacyThisWeekTarget {
  const rate = first(query.rate);
  if (rate) return { pathname: '/(app)/recipe-detail/[id]', params: { id: rate } };

  const params: Record<string, string> = {};
  const week = first(query.week);
  if (week && ISO_DAY.test(week)) params.week = week;

  const swap = first(query.swap);
  if (swap) {
    params.swap = swap;
    const day = first(query.day);
    if (day && /^\d$/.test(day)) params.day = day;
    params.meal = first(query.meal) ?? 'dinner';
  }

  return { pathname: '/(app)', params };
}
